import axios from 'axios';

export default {
  namespaced: true,
  state: {
    messages: [],
  },
  getters: {
    messages(state) {
      return state.messages;
    },
  },
  mutations: {
    SET_MESSAGES(state, messages) {
      state.messages = messages;
    },
    SET_MESSAGE(state, message) {
      state.messages.push(message);
    },
    REMOVE_MESSAGE(state, messageId) {
      let delIndex;

      state.messages.map((message, index) => {
        if (message.id === messageId) {
          delIndex = index;
        }
      });

      state.messages.splice(delIndex, 1);
    },
  },
  actions: {
    addMessage({commit}, message){
      commit('SET_MESSAGE', message);
    },
    async getAllMessage({ commit }, payload) {
      return axios.get('orders/' + payload.id + '/messages').then((response) => {
        commit('SET_MESSAGES', response.data);
      });
    },
    async storeMessage({ commit }, payload) {
      return axios
        .post('orders/' + payload.id + '/messages', payload.data)
        .then((response) => {
          commit('SET_MESSAGE', response.data);
        });
    },
    async deleteMessage({ commit }, payload) {
      return axios
        .delete('orders/' + payload.orderId + '/messages/' + payload.messageId)
        .then(() => {
          commit('REMOVE_MESSAGE', payload.messageId);
        });
    },
    async downloadAttachment(_, payload) {
      return axios.get('orders/' + payload.orderId + '/attachments/' + payload.messageId, {responseType: 'blob'});
    },
  },
};
